export function readMinutes(content: string): number {
	const words = content.trim().split(/\s+/).filter(Boolean).length
	return Math.max(1, Math.round(words / 200))
}

export function excerpt(content: string, max = 140): string {
	const clean = content.replace(/\s+/g, ' ').trim()
	return clean.length > max ? `${clean.slice(0, max)}…` : clean
}
